package com.anjuros.website.templates.template9.sections

import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import com.anjuros.website.templates.template9.components.Template9ReviewCard
import com.anjuros.website.templates.template9.components.Template9SectionTitle
import com.anjuros.website.templates.template9.modules.Template9Review
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9SectionPaddingStyle
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template9ReviewSection() {
    Box(
        modifier = Template9SectionPaddingStyle.toModifier()
            .id("reviews")
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb),
        contentAlignment = Alignment.TopCenter
    ) {
        Image(
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.CenterEnd)
                .size(70.px)
                .margin(right = 30.px)
                .opacity(0.6f),
            src = Template9Res.Icon.paw_watermark,
            alt = ""
        )
        Image(
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.BottomStart)
                .size(56.px)
                .margin(left = 40.px, bottom = 60.px)
                .opacity(0.6f),
            src = Template9Res.Icon.paw_watermark,
            alt = ""
        )

        Column(
            modifier = Template9ContainerStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template9Reveal(contentAlignment = Alignment.TopCenter) {
                Template9SectionTitle(
                    eyebrow = ResKey.TEMPLATE9_REVIEWS_EYEBROW,
                    title = ResKey.TEMPLATE9_REVIEWS_TITLE
                )
            }
            SimpleGrid(
                numColumns = numColumns(base = 1, md = 3),
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = 44.px)
                    .gap(24.px)
            ) {
                Template9Review.entries.forEach { review ->
                    Template9Reveal(
                        modifier = Modifier.fillMaxWidth().fillMaxHeight(),
                        delayMs = review.ordinal * 150
                    ) {
                        Template9ReviewCard(review)
                    }
                }
            }
        }
    }
}
